export const environment = {
  production: false,
  useHttps: true,
  title: 'Servkomm',
  logo: 'assets/images/logo.png',
  apiStoragePrefix: 'sk-stage-',
  services: {
    structure: 'https://stage.servkomm.de/v1/api/structure',
    driver: 'https://stage.servkomm.de/v1/api/driver',
    live: 'https://stage.servkomm.de/v1/api/live',
    historian: 'https://stage.servkomm.de/v1/api/historian',
    event: 'https://stage.servkomm.de/v1/api/event',
    camera: 'https://stage.servkomm.de/v1/api/camera',
    reporting: 'https://stage.servkomm.de/v1/api/reporting',
    messenger: 'https://stage.servkomm.de/v1/api/messenger',
    ticket: 'https://stage.servkomm.de/v1/api/tickets',
    calendar: 'https://stage.servkomm.de/v1/api/calendar',
    timeSchedules: 'https://stage.servkomm.de/v1/api/timeschedules'
  }
};

// export const environment = {
//   production: false,
//   useHttps: true,
//   title: 'Servkomm',
//   logo: 'assets/images/logo.png',
//   apiStoragePrefix: 'sk-',
//   services: {
//     structure: 'https://portal.servkomm.de/api/structure',
//     driver: 'https://portal.servkomm.de/api/driver',
//     live: 'https://portal.servkomm.de/api/live',
//     historian: 'https://portal.servkomm.de/api/historian',
//     event: 'https://portal.servkomm.de/api/event',
//     camera: 'https://portal.servkomm.de/api/camera',
//     reporting: 'https://portal.servkomm.de/api/reporting',
//     messenger: 'https://portal.servkomm.de/api/messenger',
//     ticket: 'https://portal.servkomm.de/api/tickets',
//     calendar: 'https://portal.servkomm.de/api/calendar',
//     timeSchedules: 'https://portal.servkomm.de/api/timeschedules'
//   }
// };
